import React from 'react';

function PowerBI() {
  return (
    <div className="w-full h-screen min-h-[920px] flex justify-center items-center">
      <iframe
        title="RELATÓRIOS_VIZION_VIVO"
        src="https://app.powerbi.com/view?r=eyJrIjoiY2VjNTFiZDQtOGY1Mi00MmZiLTgwYWYtYmIwOTcyZDNiN2FhIiwidCI6ImM1MDc2OTcyLTU4ZDAtNDVmMy1iYzFjLTI1Y2Q4ZDQ4MjFlZCJ9"
        // src="https://app.powerbi.com/reportEmbed?reportId=bc2bbd6f-0c5b-4c4e-a96a-c3bba8a65121&autoAuth=true&ctid=c5076972-58d0-45f3-bc1c-25cd8d4821ed" 
        className="w-full h-full"
        allowFullScreen={true}
        frameBorder="0"
      ></iframe>
    </div>
  );
}

export default PowerBI;
